export const SET_ROUTE = '@router/SET_ROUTE';
/** Parameters in hash was updated from application code */
export const UPDATE_HASH_PARAMS = '@router/UPDATE_HASH_PARAMS';
//# sourceMappingURL=constants.js.map